import { DatePipe, NgIf } from '@angular/common';
import { Component, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { FuseAlertComponent } from '@fuse/components/alert';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { LollySchedulerService } from 'app/services/lolly-scheduler.service';
import { SnackbarService } from 'app/services/snackbar.service';
import { NgxLoadingModule } from 'ngx-loading';
import { ErrorPageComponent } from '../error-page/error-page.component';
import { CancelBookingPayload, LollyBooking } from 'app/models/bookings.model';

@Component({
  selector: 'app-booking-cancel',
  standalone: true,
  imports: [MatIconModule, FuseAlertComponent, NgxLoadingModule, NgIf, DatePipe, MatDialogModule, MatInputModule, MatButtonModule ,FormsModule,ErrorPageComponent],
  templateUrl: './booking-cancel.component.html',
  styleUrl: './booking-cancel.component.scss'
})
export class BookingCancelComponent {

  dialogRef!: MatDialogRef<any>;

  constructor(
    private _fuseConfirmationService: FuseConfirmationService,
    private _lollySchedulerService: LollySchedulerService,
    private route: ActivatedRoute,
    private _snackbarService: SnackbarService,
    public dialog: MatDialog,
    public router: Router,

  ) { }

  id: string = null;
  cancelDone: boolean = false;
  bookingData: LollyBooking = new LollyBooking()

  cancelBookingPayload:CancelBookingPayload = new CancelBookingPayload();
  error:boolean=false

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id')!;
      if (this.id) {
        this.loadBookingData();
      }
    });
  }

  loading: boolean = false

  onCancel() {

  }

  fetchData(id: string) {

  }

  onConfirmCancel() {
    const confirmation = this._fuseConfirmationService.open({
      title: 'Cancel Booking',
      message: `You are about to cancel the booking.`,
      actions: {
        confirm: {
          label: 'Yes, Cancel Booking',
          color: 'warn',
        },
      },
      icon: {
        color: 'warn',
        name: 'heroicons_outline:exclamation-triangle',
      },
    });

    confirmation.afterClosed().subscribe((result) => {
      if (result === 'confirmed') {
        this.cancelBooking()
      }
    });
  }

  cancelBooking() {
    this.loading = true;
    this.cancelBookingPayload.calendarEventIdentifier = this.bookingData.calendar_event_identifier;
    this._lollySchedulerService
      .cancelBooking(this.cancelBookingPayload, this.id)
      .then((res) => {
        this.loading = false;
        this._snackbarService.successSnackbar(
          'Booking cancelled successfully!'
        );
        this.cancelDone = true
        this.dialogRef.close()
      })
      .catch((err) => {
        this.error = 
        this.loading = false;
        this.dialogRef.close()
        console.log(err);
      });
  }

  loadBookingPage() {
    window.location.href = `/bookings/${this.bookingData.account_session_uuid}`
  }

  loadBookingData() {
    this.loading = true
    this._lollySchedulerService.getBookingData(this.id).then(res => {
      this.bookingData = this._lollySchedulerService.getData(res)
      if(!this.bookingData){
        this.error =true
        return
      }  

    }).catch(error => {
      // this.router.navigate(['/error']);
      this.error = true
      console.log(error)
    }).finally(()=>{
      this.loading = false
    })
  }

  openDialog(templateRef: TemplateRef<any>): void {
    this.dialogRef = this.dialog.open(templateRef, {
      width: '600px',
    });
  }

  onNoteChange(event){
    console.log(event)
  }

}
